import React from "react";

export default function SoftapiExamples() {
  const curlText = `# after 'softapi new' + 'uvicorn app.main:app --reload'
curl -X POST http://localhost:8000/auth/login \\
  -H "Content-Type: application/json" \\
  -d '{"username":"demo","password":"demo"}'`;

  const curlOutput = `# -> example JSON response
{
  "access_token": "eyJhbGciOi...<snip>...s8",
  "token_type": "bearer"
}

# now hit a protected route
curl http://localhost:8000/protected \\
  -H "Authorization: Bearer YOUR_TOKEN_HERE"`

  const protectedOutput = `# -> example JSON response
{
  "msg": "Hello, demo. This is a protected endpoint!"
}`;

  return (
    <main className="docs-wrap">
      <div className="docs-layout">
        <aside className="docs-toc">
          <strong>On this page</strong>
          <a href="#intro">Intro</a>
          <a href="#auth">Auth quick test</a>
        </aside>

        <article>
          <header className="stt-hero">
            <div className="stt-pill">softapi • Examples</div>
            <h1 className="stt-h1">Try the generated API</h1>
            <p className="stt-lead">Spin up and hit endpoints locally.</p>
          </header>

          <section id="intro" className="stt-section">
            <p className="stt-p">
              Generate a project, run Uvicorn, then hit endpoints with
              curl/Postman.
            </p>
          </section>

          <section id="auth" className="stt-section stt-card">
            <h2 className="stt-card-title">Auth quick test</h2>
            <div className="stt-card-body">
              <div className="stt-code">
                <pre className="stt-pre">{curlText}</pre>
              </div>
              <div className="stt-output">
                <pre className="stt-pre">{curlOutput}</pre>
              </div>
              <div className="stt-output">
                <pre className="stt-pre">{protectedOutput}</pre>
              </div>
            </div>
          </section>
        </article>
      </div>
    </main>
  );
}
